import React, { useEffect, useState } from "react";
import { PageHeader } from "@/components/PageHeader";
import { Section, Reveal } from "@/components/primitives";
import { getContent, trackEvent } from "@/lib/api";
import { CalendarBlank, MapPin } from "@phosphor-icons/react";

const TYPE_COLORS = {
  Leadership: "text-[#2DD4BF] border-[#2DD4BF]/40 bg-[#2DD4BF]/10",
  Webinar: "text-[#0E9E90] border-[#0E9E90]/40 bg-[#0E9E90]/10",
  Training: "text-emerald-300 border-emerald-400/40 bg-emerald-400/10",
  Regional: "text-amber-300 border-amber-400/40 bg-amber-400/10",
};

function fmtDate(d) {
  try {
    return new Date(d).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return d;
  }
}

export default function Events() {
  const [events, setEvents] = useState([]);
  useEffect(() => {
    trackEvent("page_view", { page: "events" });
    getContent("events").then(setEvents).catch(() => {});
  }, []);
  return (
    <div>
      <PageHeader
        eyebrow="Corporate Events"
        title="Meetings, webinars, and product demonstrations."
        sub="Global leadership meetings, webinars, technology presentations, training sessions, and regional events."
      />
      <Section grid>
        <div className="space-y-4" data-testid="events-list">
          {events.map((e, i) => (
            <Reveal key={e.id} delay={i * 0.05}>
              <div className="group flex flex-col md:flex-row md:items-center gap-5 rounded-xl border border-white/10 bg-[#0A0B10] p-6 hover:border-[#2DD4BF]/30 transition-colors">
                <div className="shrink-0 grid place-items-center h-16 w-16 rounded-lg border border-white/10 bg-white/[0.03] text-center">
                  <CalendarBlank size={22} className="text-[#2DD4BF]" weight="duotone" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-3 mb-2">
                    <span className={`rounded-full border px-2.5 py-1 font-mono text-[10px] uppercase tracking-widest ${TYPE_COLORS[e.type] || "text-[#94A3B8] border-white/15"}`}>
                      {e.type}
                    </span>
                    <span className="font-mono text-xs text-[#94A3B8]">{fmtDate(e.date)}</span>
                  </div>
                  <h3 className="text-lg font-bold text-white">{e.title}</h3>
                  <p className="text-sm text-[#94A3B8] mt-1">{e.desc}</p>
                </div>
                <div className="shrink-0 flex items-center gap-1.5 text-sm text-[#cbd5e1]">
                  <MapPin size={15} className="text-[#0E9E90]" /> {e.location}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>
    </div>
  );
}
